import { downloadReportEpic } from './downloadReportEpic';
import { getTermReportConfigsEpic } from './getTermReportConfigsEpic';
import searchReportsEpic from './searchReportsEpic';
import initiateBulkUploadFilesEpic from './initiateBulkUploadFilesEpic';
import filePartsUploadEpic from './filePartsUploadEpic';
import completeBulkUploadFilesEpic from './completeBulkUploadFilesEpic';
import uploadFileFolderEpic from './uploadFileFolderEpic';
import deleteReportEpic from './deleteReportEpic';
import bulkDownloadReportsEpic from './bulkDownloadReportsEpic';
import downloadReportPresignedURLEpic from './downloadReportPresignedURLEpic';
import getReportDetailsEpic from './getReportDetailsEpic';
import approveReportEpic from './approveReportEpic';
import rejectReportEpic from './rejectReportEpic';
import getReportDetailsPollingEpic from './getReportDetailsPollingEpic';
import getPresignedUrlEpic from './getPresignedUrlEpic';

export const reportsCenterEpics = [
  getTermReportConfigsEpic,
  downloadReportEpic,
  searchReportsEpic,
  initiateBulkUploadFilesEpic,
  filePartsUploadEpic,
  completeBulkUploadFilesEpic,
  uploadFileFolderEpic,
  deleteReportEpic,
  bulkDownloadReportsEpic,
  downloadReportPresignedURLEpic,
  getReportDetailsEpic,
  approveReportEpic,
  rejectReportEpic,
  getReportDetailsPollingEpic,
  getPresignedUrlEpic,
];

export default reportsCenterEpics;
